export default "__VITE_ASSET__oOvnYVfu__"